import { render, staticRenderFns } from "./CreateColumnCategory.vue?vue&type=template&id=90b88d76&"
import script from "./CreateColumnCategory.vue?vue&type=script&lang=js&"
export * from "./CreateColumnCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports